import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import APIList from '../../../../http/ApiList';
import { cloneDeep, isObject, isString } from 'lodash';
import ErrorBoundary from '../../../common/error-boundary';
import { WaterFallChart } from '@meteor/frontend-core';

const CustomizeWaterFallChart: React.FC<any> = (props) => {
  const { authInfo, echartTheme, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [chartLoading, setChartLoading] = useState<any>(false);
  const [chartData, setChartData] = useState<any>(null);
  const defaultChartOptions: any = {
    grid: {
      bottom: 40,
      top: 35,
      right: 20,
      left: 40,
    },
    legend: {
      type: 'scroll',
      data: [],
      right: 0,
      top: 0,
      width: '80%',
    },
    xAxis: {
      type: 'category',
      name: 'xName',
      nameLocation: 'center',
      scale: true,
      nameGap: 25,
    },
    yAxis: {
      type: 'value',
      name: 'yName',
      scale: true,
    },
    tooltip: {
      appendToBody: true,
      className: 'overflow-all',
      hideDelay: 0,
      formatter: function (params) {},
    },
  };
  const [options, setOptions] = useState<any>(defaultChartOptions);
  const [chartOptions, setChartOptions] = useState<any>(null);

  const getChartData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setChartOptions(res.options);
        setTimeout(() => {
          setChartData(res.data);
          setChartLoading(false);
        });
      });
  };

  useEffect(() => {
    if (!property || !property.chartOptions || !property.chartOptions.options) {
      return;
    }
    let tempOptions = property.chartOptions.options;
    if (chartOptions) {
      tempOptions = chartOptions;
    }
    try {
      let op;
      if (tempOptions && isString(tempOptions)) {
        const reviver = (key, value) => {
          const arrowFunctionRegex = /^\s*\(?\s*([^)]*)\s*\)?\s*=>\s*{[^]*}$/;
          if (typeof value === 'string' && (value.startsWith('function') || arrowFunctionRegex.test(value))) {
            return new Function('return ' + value)();
          }
          return value;
        };
        const tempOp = JSON.parse(tempOptions, reviver);
        op = {
          ...options,
          ...tempOp,
        };
      } else if (tempOptions && isObject(tempOptions)) {
        op = tempOptions;
      } else {
        op = defaultChartOptions;
      }
      setOptions(cloneDeep({ ...op, echartTheme }));
    } catch (error) {}
  }, [property, chartOptions]);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      setChartLoading(true);
      setTimeout(() => {
        getChartData(globalEvent);
      }, 500);
    }
  }, [globalEvent]);

  useEffect(() => {
    if (!chartData || chartData.length === 0) {
      return;
    }
  }, [chartData]);

  return (
    <ErrorBoundary>
      <WaterFallChart
        title={{
          value: (
            <>
              <span>{property.title}</span> <span style={{ float: 'right' }}>{property.subtitle}</span>
            </>
          ),
          styles: {},
        }}
        chartOptions={options}
        showSeriesLabel={false}
        mouseWheelZoomLock={false}
        loading={chartLoading}
        chartData={chartData}
        height={'90%'}
        tooltips={['zoomIn']}
        isBank={!chartData || chartData.length === 0}
        onChartEvent={setGlobalEvent}
      />
    </ErrorBoundary>
  );
};

export default CustomizeWaterFallChart;
